import EverRollSettings from "@/components/advisor/settings/EverRollSettings";
import FSSExpress from "@/components/fss-reports/FSSExpress";
import { connect } from "react-redux";
import { Navigate, Route, Routes } from "react-router-dom";
import AdvisorBilling from "../components/advisor/billing/AdvisorBilling";
import AdvisorClients from "../components/advisor/clients/AdvisorClients";
import AdvisorPayrolls from "../components/advisor/payrolls/AdvisorPayrolls";
import AdvisorSchedule from "../components/advisor/schedule/AdvisorSchedule";
import AdvisorSettings from "../components/advisor/settings/AdvisorSettings";
import AdvisorTeam from "../components/advisor/team/AdvisorTeam";
import AdvisorAcceptInvite from "@/components/advisor/AdvisorAcceptInvite";
import AdvisorChoosePlan from "@/components/advisor/AdvisorChoosePlan";
import Notifications from "@/components/notifications/Notifications";
import { format } from "date-fns";
import AdvisorTaxForms from "@/components/advisor/taxForms/advisorTaxForms";
import CISModal from "@/components/fss-reports/CISModal";
import AdvisorDashboard from "@/components/advisor/dashboard/AdvisorDashboard";
import Reports from "@/components/advisor/reports/Reports";
import ReportPackEdit from "@/components/advisor/reports/ReportPackEdit";

const Advisor = ({ permissions, showAdvisorChoosePlan }) => {
	if (permissions?.status === "Pending") return <AdvisorAcceptInvite />;
	if (showAdvisorChoosePlan) return <AdvisorChoosePlan />;

	return (
		<>
			<CISModal />
			<Routes>
				<Route
					path="/notifications"
					element={<Notifications />}
				/>
				<Route
					path="clients"
					element={<AdvisorClients />}
				/>
				<Route
					path="billing/*"
					element={<AdvisorBilling />}
				/>
				<Route
					path="fss-xpress"
					element={<FSSExpress forAdvisor={true} />}
				/>
				<Route
					path="payrolls"
					element={<AdvisorPayrolls />}
				/>
				<Route
					path="tasks"
					element={<AdvisorSchedule />}
				/>
				<Route
					path="ever-roll"
					element={<EverRollSettings />}
				/>
				<Route
					path="team"
					element={<AdvisorTeam />}
				/>
				<Route
					path="settings/*"
					element={<AdvisorSettings />}
				/>
				<Route
					path="reports/*"
					element={<Reports />}
				/>
				<Route
					path="reports/reportPacks/:id/*"
					element={<ReportPackEdit />}
				/>
				<Route
					path="tax-forms"
					element={<AdvisorTaxForms />}
				/>
				<Route
					path="dashboard/*"
					element={<AdvisorDashboard />}
				/>
				<Route
					path="*"
					element={
						<Navigate
							to="/advisor/clients"
							replace
						/>
					}
				/>
			</Routes>
		</>
	);
};

const mapStateToProps = (state) => {
	const { planRenewalDate, trialExpires } = { ...state.advisors?.settings };
	let showAdvisorChoosePlan =
		((planRenewalDate || trialExpires) && (planRenewalDate ?? trialExpires) < format(new Date(), "yyyy-MM-dd")) ||
		state.payment?.creditId ||
		state.payment.advisorModal;

	return {
		permissions: state.advisors?.permissions,
		isAdmin: state.my.profile.isAdmin,
		showAdvisorChoosePlan,
	};
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Advisor);
